module.exports = __webpack_public_path__ + "img/xingsuan-qrcode.5334fef0.png";